import { useQuery } from "@tanstack/react-query";
import type { MoneyConfig } from "@/lib/money/session-money";

/**
 * Fetches the live rate config. Throws on a failed request instead of guessing a
 * value: this config feeds computations that get persisted (stored gross client
 * price), and a plausible wrong number is worse than a visible loading/error state.
 */
export async function fetchPricingConfig(): Promise<MoneyConfig> {
  const res = await fetch("/api/pricing-config");
  if (!res.ok) {
    throw new Error("Greška pri učitavanju konfiguracije cijena");
  }
  return (await res.json()) as MoneyConfig;
}

export interface PricingConfigState {
  /** null dok se ne učita ili ako zahtjev nije uspio; nikad pogađena vrijednost. */
  config: MoneyConfig | null;
  isLoading: boolean;
  isError: boolean;
}

export function usePricingConfig(): PricingConfigState {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["pricing-config"],
    queryFn: fetchPricingConfig,
    staleTime: 5 * 60 * 1000,
  });
  return { config: data ?? null, isLoading, isError };
}
